export default "__VITE_ASSET__ayq$aYLy__"